// Floating score popups (v1 ui-manager showScorePopup + game3d projection
// at js/game3d.js:1062-1076).

import type * as THREE from 'three';

export class PopupLayer {
  private readonly layer: HTMLElement;

  constructor(root: HTMLElement) {
    this.layer = document.createElement('div');
    this.layer.className = 'popup-layer';
    root.appendChild(this.layer);
  }

  show(text: string, x: number, y: number, color = '#FFD700', big = false): void {
    const el = document.createElement('div');
    el.className = big ? 'score-popup big' : 'score-popup';
    el.textContent = text;
    el.style.left = `${x}px`;
    el.style.top = `${y}px`;
    el.style.color = color;
    this.layer.appendChild(el);
    setTimeout(() => el.remove(), 1200);
  }

  /** Project a world position and show the popup there (skips off-screen). */
  showAtWorld(
    text: string,
    worldPos: THREE.Vector3,
    camera: THREE.Camera,
    color = '#FFD700',
    big = false,
  ): void {
    const projected = worldPos.clone();
    projected.y += 0.8; // Float above the object (v1 :1067)
    projected.project(camera);
    if (projected.z > 1 || Math.abs(projected.x) > 1.2 || Math.abs(projected.y) > 1.2) return;
    const x = (projected.x * 0.5 + 0.5) * window.innerWidth;
    const y = (-projected.y * 0.5 + 0.5) * window.innerHeight;
    this.show(text, x, y, color, big);
  }
}
